import { useState } from 'react';
import './WelcomeModal.css';

const STEPS = [
  {
    icon: '📊',
    title: 'Terminál',
    body: 'A főoldalon látod a BTC árát és chartját, a Félelem & Mohóság indexet, az Altseason indexet, a nap mozgóit és a következő makroeseményt. Minden kártya alján ott a forrás és a frissítés ideje.',
  },
  {
    icon: '🔍',
    title: 'RSI-áttekintés, Szkenner & Hőtérkép',
    body: 'Valódi RSI a Bybit lezárt gyertyáiból: a Szkenner a top 100 coin napi RSI-jét mutatja, az RSI-áttekintés fülön egy coint 15 perctől napi idősíkig nézhetsz meg. A címkék állapotot írnak le (túladott, túlvett), nem vételi tanácsot adnak.',
  },
  {
    icon: '⚡',
    title: 'Derivatívák, Funding & Stratégiák',
    body: 'Open interest, long/short arány, funding ráták és a Deribit put/call aránya. A Stratégiák fül megmutatja, mely piaci feltételek teljesülnek éppen.',
  },
  {
    icon: '💼',
    title: 'Kalkulátor, Trade Tervező & Portfólió',
    body: 'Tervezd meg a trade-jeidet entry/SL/TP szintekkel, és kövesd a portfóliódat. Ezek az adatok csak ezen az eszközön tárolódnak — a fejléc alatti „Export” gombbal bármikor lementheted őket.',
  },
  {
    icon: '📅',
    title: 'Naptár & ETF',
    body: 'A Naptár a fontos makroeseményeket (Fed, CPI, munkaerőpiac) gyűjti. Az ETF fül statikus összefoglaló az intézményi termékekről, dátummal jelölve.',
  },
  {
    icon: '🔔',
    title: 'Riasztások',
    body: 'Állíts be egy riasztást, és kösd össze a Telegramot. A coin fejlécében a „🔔 Riasztás”, a Trade Tervezőben a „Riasztások a tervhez” gomb egy kattintással beállítja; a fejléc csengőjénél kezeled őket.',
  },
].map((s, i, all) => ({ ...s, num: `${i + 1} / ${all.length}` }));

export default function WelcomeModal({ onDone }) {
  const [step, setStep] = useState(0);
  const isLast = step === STEPS.length - 1;
  const { icon, num, title, body } = STEPS[step];

  function finish() {
    localStorage.setItem('onboarding_completed', 'true');
    onDone();
  }

  return (
    <div className="wm-overlay">
      <div className="wm-modal">
        <div className="wm-top-bar" />

        {/* Header */}
        <div className="wm-head">
          <div className="wm-emoji">🎉</div>
          <div className="wm-logo">Üdv a Kripto Terminálban!</div>
          <div className="wm-sub">Szia! Örülünk, hogy itt vagy. Gyors bemutató következik.</div>
        </div>

        {/* Step card — keyed on step so CSS animation fires on each change */}
        <div className="wm-card-wrap">
          <div key={step} className="wm-step-card">
            <div className="wm-step-icon">{icon}</div>
            <div className="wm-step-num">{num}</div>
            <div className="wm-step-title">{title}</div>
            <div className="wm-step-body">{body}</div>
          </div>
        </div>

        {/* Progress dots */}
        <div className="wm-dots">
          {STEPS.map((_, i) => (
            <button
              key={i}
              className={[
                'wm-dot',
                i < step  && 'wm-dot--done',
                i === step && 'wm-dot--cur',
              ].filter(Boolean).join(' ')}
              onClick={() => setStep(i)}
              aria-label={`Lépés ${i + 1}`}
            />
          ))}
        </div>

        {/* Navigation */}
        <div className="wm-nav">
          {isLast ? (
            <button className="wm-btn wm-btn--start" onClick={finish}>
              🚀 Kezdjük el!
            </button>
          ) : (
            <>
              <button className="wm-btn wm-btn--next" onClick={() => setStep(s => s + 1)}>
                Következő →
              </button>
              <button className="wm-skip" onClick={finish}>Ugrás →</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
